















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Debounce } from '@/jbi-shared/util/debounce.vue-decorator';

@Component
export default class SearchBox extends Vue {
  @Prop({ type: String, default: '' })
  public value!: string;

  @Prop({ type: String, default: 'Search' })
  public placeholder!: string;

  public internalQuery = '';

  public created(): void {
    this.internalQuery = this.value;
  }

  /**
   * Watches for changes on the input field and emits an 'input' event
   * after 500ms of inactivity. This is for the parent component's v-model.
   */
  @Watch('internalQuery')
  @Debounce(500)
  public onSearch(): void {
    this.$emit('input', this.internalQuery);
  }

  /**
   * If the parent component changes the 'value' prop (e.g. clears the search),
   * this watcher ensures the internal state of this component is updated.
   */
  @Watch('value')
  public onValueChanged(newValue: string): void {
    this.internalQuery = newValue;
  }
}
